import Kithara from "src/services/kithara";
const kithara = new Kithara();

export default {
  actions: {
    download({ rootState }) {
      return kithara
        .download(rootState.route.params.playlistId)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "kithara.html");
          document.body.appendChild(link);
          link.click();
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/download.js